import { render, staticRenderFns } from "./wisdom_home.vue?vue&type=template&id=269cfcc7&scoped=true&"
import script from "./wisdom_home.vue?vue&type=script&lang=js&"
export * from "./wisdom_home.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_home.vue?vue&type=style&index=0&id=269cfcc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269cfcc7",
  null
  
)

export default component.exports